import React from 'react';
import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import Modal from '../../../../shared/components/Modals/Modal.jsx';
import CardCol from "../../Styled/Dasboard/CardCol.jsx";
import ActivateCdiForm from "../../Forms/MySearchForms/ActivateCdiForm.jsx";
import ActiveCdiSubmitButton from "../../Forms/MySearchForms/ActiveCdiSubmitButton.jsx";
import CardRow from "../../Styled/Dasboard/CardRow.jsx";

class CdiStatusFormModal extends Modal {
  static propTypes = {
    confirmAction: PropTypes.func,
    onCancel: PropTypes.func,
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    header: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    confirmText: PropTypes.string,
    className: PropTypes.string,
    myClassName: PropTypes.string,
    cancelClose: PropTypes.func,
  }
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }
  cancel = () => {
    if(this.props.onCancel){
      this.props.onCancel()
    }
    this.props.closeModal();
  };

  confirm = () => {
    this.props.confirmAction();
    this.props.closeModal();
  };

  render() {
    const modalProps = {};
    const {header, freelance, user, className} = this.props

    if (!this.state.loading) {
      modalProps.toggle = this.close;
    }

    return (
      <BootstrapModal toggle={this.cancel} isOpen={this.props.isOpen} className={className ? className : ''}>
        <ModalHeader toggle={this.cancel}>{header}</ModalHeader>
        <ModalBody>
          <CardRow direction="column">
            <CardCol>
              <p className="txt">
                Pouvez-vous nous communiquer votre nouvelle affectation ? Cette réponse ne sera en aucun cas communiquée, elle servira simplement à compléter votre profil.
                {' '}
                <strong>Ces informations ne sont pas obligatoires.</strong>
              </p>
              <ActivateCdiForm
                enableReinitialize={true}
                onSubmit={(values) => {
                  const {freelance, user} = values

                  const freelanceData = {
                    cdi: true,
                    date_cdi_start: freelance.date_cdi_start,
                    title: freelance.title
                  }

                  const userData = {
                    company: user.company
                  }

                  this.props.handleCdiStatusChange(freelanceData, userData)
                    .then((response) => {
                      if (false === response) {
                        this.initialiseForm()
                      }
                    }).finally(() => {
                      this.props.closeModal()
                    })
                }}
                initialValues={{
                  freelance,
                  user,
                }}/>
            </CardCol>
          </CardRow>
          <div className="d-flex justify-content-around">
            <button onClick={this.cancel} type="button" className="btn btn-primary">Annuler</button>
            <ActiveCdiSubmitButton className="btn btn-secondary">Sauvegarder</ActiveCdiSubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default withRouter(CdiStatusFormModal);
